import { createContext, useContext } from 'react'
import ClientsStore from '../../entities/client/model/ClientStore'
import ServicesStore from '../../entities/service/model/ServiceStore'
import BookingStore from '../../entities/booking/model/BookingStore'
import BookingAddStore from '../../features/bookings/model/BookingAddStore'
import OrganizationStore from '../../entities/organization/model/OrganizationStore'
import WorkingHoursStore from '../../entities/working-hours/model/WorkingHoursStore'
import AuthStore from '../../shared/model/AuthStore'
import SortStore from '../../shared/model/SortStore'
import LayoutStore from '../../shared/model/LayoutStore'
import FeedbackStore from '../../features/feedback/model/FeedbackStore'
import MapStore from '../../features/organization/map-picker/model/MapStore'
import ThemeStore from '../../shared/model/ThemeStore'
import ErrorStore from '../../shared/model/ErrorStore'
import DashboardStore from '../../widgets/dashboard/model/DashboardStore'
import StaffStore from '../../entities/staff/model/StaffStore'
import UserStore from '../../entities/user/model/UserStore'
import { useRouter } from '../../shared/hooks/router'
import TourStore from '../../features/organization/map-picker/ui/TourStore'

class RootStore {
  constructor() {
    this.layoutStore = new LayoutStore(this)
    this.themeStore = new ThemeStore()
    this.sortStore = new SortStore()
    this.errorStore = new ErrorStore()
    this.authStore = new AuthStore(this)
    this.mapStore = new MapStore(this)
    this.organizationStore = new OrganizationStore(this)
    this.staffStore = new StaffStore(this)
    this.userStore = new UserStore(this)
    this.clientsStore = new ClientsStore(this)
    this.servicesStore = new ServicesStore(this)
    this.workingHoursStore = new WorkingHoursStore(this)
    this.bookingsStore = new BookingStore(this)
    this.dashboardStore = new DashboardStore(this)
    this.bookingAddStore = new BookingAddStore(this)
    this.feedbackStore = new FeedbackStore(this)
    this.tourStore = new TourStore(this)
  }
}

const StoresContext = createContext(new RootStore())

export const useStores = () => useContext(StoresContext)

// Для внедрения router (который является хуком) в сторы, можно
// использовать такой компонент-обертку в корне приложения.
export const StoreProvider = ({ children }) => {
  const router = useRouter()
  const stores = useContext(StoresContext)

  // Внедряем router в сторы, которым он нужен
  stores.bookingAddStore.router = router
  stores.organizationStore.router = router
  stores.tourStore.router = router

  return (
    <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>
  )
}
